import Checkbox from './checkbox/CheckboxInput';
import Field from './field/InputField';
import Image from './image/ImageInput';
import Number from './number/NumberInput';
import Password from './password/PasswordInput';
import Select from './select/SelectInput';
import Switch from './switch/SwitchInput';
import Text from './text/TextInput';
import ComplexWrapper from './wrapper/complex/ComplexInputWrapper';

export default {
  Text,
  Number,
  Password,
  Select,
  Checkbox,
  ComplexWrapper,
  Field,
  Image,
  Switch,
};
